import { render, staticRenderFns } from "./BibliographyIntegrationInfoTable.vue?vue&type=template&id=5f22fa39&"
import script from "./BibliographyIntegrationInfoTable.vue?vue&type=script&lang=ts&"
export * from "./BibliographyIntegrationInfoTable.vue?vue&type=script&lang=ts&"
import style0 from "./BibliographyIntegrationInfoTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports